var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.arbitrationVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.arbitrationVisible,
            "show-close": false,
            close: _vm.back,
            width: _vm.IS_MOBILE ? "90%" : "1000px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.arbitrationVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "arbitration-dialog" }, [
            _c(
              "div",
              {
                staticClass: "arbitration-dialog-title",
                on: { click: _vm.back }
              },
              [
                _c("i", { staticClass: "el-icon-arrow-left" }),
                _vm._v(" "),
                _c("span", { staticClass: "arbitration-dialog-back" }, [
                  _vm._v("Back")
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "arbitration-dialog-text" }, [
              _vm._v(
                "\n      If the two parties cannot reach an agreement, you can initiate platform arbitration to intervene in the process\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arbitration-dialog-description" }, [
              _c("span", [_vm._v("Arbitration Description")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.arbitrationDes,
                      callback: function($$v) {
                        _vm.arbitrationDes = $$v
                      },
                      expression: "arbitrationDes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.arbitrationDes
                ? _c(
                    "div",
                    { staticStyle: { color: "red", "margin-bottom": "20px" } },
                    [_vm._v("Please Enter Arbitration Description")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arbitration-dialog-description" }, [
              _c("span", [_vm._v("Submit Arbitration Credentials")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("img-swiper", {
                    ref: "imgSwiper",
                    attrs: { edit: true, maxLength: 30 }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arbitration-dialog-button" }, [
              _c("div", { on: { click: _vm.back } }, [_vm._v("Cancel")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "arbitration-dialog-button-application",
                  on: { click: _vm.sumbit }
                },
                [_vm._v("Submit arbitration")]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fb47ac1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb47ac1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/arbitration-dialog.vue
// module id = 19AL
// module chunks = 2